import React, { useState } from 'react';
import { Building } from 'lucide-react';
import { StepButtons } from '../ui';

interface BuildingDetailsStepProps {
  value: {
    buildingDetails: {
      units: number;
      commonAreas: boolean;
    };
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const BuildingDetailsStep: React.FC<BuildingDetailsStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleDetailsChange = (field: keyof typeof value.buildingDetails, newValue: any) => {
    onChange('buildingDetails', {
      ...value.buildingDetails,
      [field]: newValue
    });
  };

  const handleFocus = () => {
    setIsFocused(true);
    handleDetailsChange('units', '');
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-primary">Détails de l'immeuble</h2>
      
      <div className="card">
        <div className="flex items-center mb-4">
          <Building className="h-6 w-6 text-primary mr-3" />
          <span className="font-medium text-neutral-800">Nombre de logements</span>
        </div>
        <input
          type="number"
          value={isFocused ? value.buildingDetails.units || '' : value.buildingDetails.units || 1}
          onChange={(e) => handleDetailsChange('units', parseInt(e.target.value) || '')}
          onFocus={handleFocus}
          onBlur={() => setIsFocused(false)}
          min="1"
          className="input w-full"
          placeholder="Nombre de logements dans l'immeuble"
        />
      </div>

      <div className="card">
        <label className="flex items-center space-x-3">
          <input
            type="checkbox"
            checked={value.buildingDetails.commonAreas}
            onChange={(e) => handleDetailsChange('commonAreas', e.target.checked)}
            className="h-4 w-4 rounded border-neutral-300 text-primary focus:ring-primary"
          />
          <span className="text-neutral-700">Inclure la rénovation des parties communes</span>
        </label>
      </div>

      <StepButtons
        onNext={onNext}
        onBack={onBack}
        disabled={!value.buildingDetails.units || value.buildingDetails.units < 1}
      />
    </div>
  );
};

export default BuildingDetailsStep;